$(function() {
    var defaults = {
        q: "",
        type: "",
        price: "",
        style: "",
        license: "",
        is_featured: "",
        sort: ""
    };

    // Track active search requests, so we can abort them
    var activeSearchRequests = [];


    // Serialize on change
    $('#search-filters').on('change', 'input, select', function() {
        var element = $(this);
        var url = element.parents('form').attr('action');
        var data = $('#search-filters').serializeObject();
        var filter = {
            name: element.attr('name'),
            value: element.val()
        };

        // Abort any active search requests
        $.each(activeSearchRequests, function(index, request) {
            request.abort();
        });

        // Filter the input against the default values
        $.each(data, function(key, value) {
            if (data[key] == defaults[key]) {
                delete data[key];
            }
        });

        // Scroll top
        $(window).scrollTop(0);

        $('#search-results .icon-grid').html(templates.render('icons/_loading.html', {
            count: 48
        }));


        // Update search results
        activeSearchRequests.push($.get(url, data, function(response) {
            var html = $(response).first('#search-results');

            $('#search-results').replaceWith(html);

            // Update the page title
            $('title').text($('#search-title').text());

            $(document).trigger('search.results');

            // Trigger pagination event
            $(window).trigger('scroll');

            // Enable tooltips
            $('#search-results [data-toggle="tooltip"]').tooltip();

            // Reset the last active search request
            activeSearchRequests.pop();
        }));

        // Track filter event
        ga('send', 'event', 'Settings', 'Filter ' + filter.name, filter.value);

        // Update search form filters
        $('.search-form [type="hidden"]').remove();

        $.each(data, function(key, value) {
            if( key != 'q' ) {
                $('<input />', {
                    type: 'hidden',
                    name: key,
                    value: value
                }).appendTo('.search-form');
            }
        });

        history.pushState(data, null, '?' + $.param(data));
    });


    // Refresh the page on history popstate (back/forward buttons)
    $(window).on('popstate', function() {
        location.reload();
    });


    // Reset all filters
    $('[data-toggle="reset-filters"]').on('click', function() {
        $.each(defaults, function(key) {
            Cookies.remove(key);
        });
    });


    // Set filters programmatically
    $(document).on('click', '[data-filter]', function() {
        var data = $(this).data();

        $('#search-filters').find('[name="'+ data.filter +'"][value="'+ data.value +'"]').click();

        // Hide any visible tooltips
        $('[data-toggle="tooltip"]').tooltip('hide');
    });


    // Sorting options dropdown
    $(document).on('click', '[data-filter="sort"]', function(e) {
        var element = $(this);
        var data = element.data();
        var title = $.trim(element.text());
        var parent = element.parents('.dropdown');

        $('#search-filters [name="sort"]').val(data.value).trigger('change');

        // Mark the sorting option as active
        parent.find('.btn[data-toggle="dropdown"]').toggleClass('active', data.value > 0);

        // Update the filter label
        parent.find('[data-toggle="dropdown"] [data-title="sorting"]').text(function() {
            if (title.length > 16) {
                title = title.substring(0, 13) + '...';
            }

            return title;
        });

        // Update the dropdown active element
        element.siblings().removeClass('active');
        element.addClass('active');

        e.preventDefault();
    });


    // Track search results actions
    $(document).on('click', '.icon-preview a', function() {
        var element = $(this);
        var icon = element.parents('.icon-preview');
        var all_icons = $('#search-results .icon-preview');
        var resultPosition = icon.index('.icon-preview') + 1;

        var actions = {
            'add-cart': 'Add icon to cart',
            'download': 'Download icon',
            'icon-details': 'Open icon details',
            'flag': 'Open flag icon modal',
            'bookmark': 'Open bookmark icon modal'
        };

        ga('send', 'event', 'Search results', actions[element.data('action')] || 'Not set', 'Position in results', resultPosition);
    });


    // Reload the results when changing settings
    $(document).on('change', '[data-setting]', function(e) {
        $('#search-filters [name="q"]').trigger('change');
    });


    // Preview size picker
    $('[data-preview_size]').on('click', function(e) {
        var element = $(this);
        var size = element.data('preview_size');

        element.siblings('.active').removeClass('active');
        element.addClass('active');

        Cookies.set('preview_size', size);

        // Reload if not search results (e.g. iconset page)
        if ($('#search-results').length) {
            $('#search-filters [name="q"]').trigger('change');
        } else {
            location.reload();
        }
    });


    // Styles filter
    $('.btn-group-styles').on('change', function(e) {
        var element = $(e.target);
        var filter = element.val();
        var menu_button = $('.dropdown-styles [data-toggle="dropdown"]');
        var menu_item = $('.dropdown-styles [data-filter="style"][data-value="'+ filter +'"]');
        var active_dropdown = menu_item.length > 0;

        $('.dropdown-styles .dropdown-item').removeClass('active');
        menu_button.toggleClass('pre-active active', active_dropdown);
        menu_item.toggleClass('active', active_dropdown);
    });


    // Toggle the search filters visibility
    $('.filters-toggle button').on('click', function() {
        $(this).find('.ui-icon').toggleClass('d-none');
        $('.search-sidebar').toggleClass('d-none');
    });


    // Persist the Safe search filter
    $('#safe-search').on('change', function() {
        var is_checked = $(this).is(':checked');

        if (is_checked) {
            Cookies.set('is_explicit', 'false');
        } else {
            Cookies.remove('is_explicit');
        }
    });
});
